export const lazyFn = (fn, args, delay = 0) => {
  setTimeout(() => {
    fn(args);
  }, delay);
};
